
import { useState, useEffect }      from 'react';
import useErrors                    from 'app/common/hooks/errors';
import useTranslate                 from 'app/common/hooks/translate';
import Validation                   from 'app/common/utils/validation';
import Textfield                    from 'app/common/uikit/textfield';
import AuthorizationContext         from 'auth/keycloak-instance';
import Phonepicker                  from 'app/common/uikit/phonepicker';
import countries                    from 'app/common/constants/countries';
import loadingAnimationData         from 'app/common/constants/loading.json';
import Lottie 					    from 'react-lottie';

const ProfileSettings = _props => {
    const profile                           = AuthorizationContext.user.profile;
    const t                                 = useTranslate();
    const [ s, setState ]                   = useState({
        username        : profile?.username,
        firstName       : profile?.firstName,
        lastName        : profile?.lastName,
        email           : profile?.email,
        attributes      : profile?.attributes,
    })

    const [ showLoading, setShowLoading ]   = useState(false);

    const { 
        errors,
        setErrors,
        clearFormErrorData
    }                                       = useErrors();

    useEffect(() => {
        setShowLoading(false);
    }, [])

    const updateFormData = (node, value) => {
        setState(prevState => ({
            ...prevState,
            [node]: value
        }))

        clearFormErrorData(node);
    }

    const saveAccount = async () => {
        
        try {
            const validation = new Validation(t);
            let phoneMinLength;
            const c = countries.find( item => item.phoneCode === parseInt(s.attributes.phoneCode) );

            if (c)
                phoneMinLength = c?.maskFormat?.replace(/[^#]/g, '').length || 10;

            const profileRules = {
                firstName           : {  required : true },
                lastName            : {  required : true },
                email               : {  required : true, type: 'email' },
            };

            const attributeRules = {
                phoneNumber         : {  required : false, minLength: phoneMinLength },
            }

            const profileValidationResult   = validation.validateData(profileRules, s);
            const attributeValidationResult = validation.validateData(attributeRules, s.attributes)
    
    
            if (!profileValidationResult.valid || !attributeValidationResult.valid) {
                let errors = {};
                if (!profileValidationResult.valid)
                    errors = profileValidationResult.fields;
                
                if (!attributeValidationResult.valid)
                    errors = { ...errors, ...attributeValidationResult.fields };

                return setErrors(errors);
            }
    
            setShowLoading(true);

            await AuthorizationContext.user.updateProfile(s);

        } catch(err) {
            console.log(err)
        } finally {
            setShowLoading(false);
        }
    }

    const changePhoneData = (phone, code) => {
        setState(prevState => ({
            ...prevState,
            attributes: {
                ...prevState.attributes,
                phoneNumber: phone,
                phoneCode: code,
            }
        }));

        clearFormErrorData('phoneNumber');
    }

    return (
        <>
            {
                showLoading
                    ?   <div id="application-loader">
                            <div className="spinner-container">
                                <Lottie 
                                    options	= {{ 
                                        loop			: true,
                                        autoplay		: true,
                                        animationData	: loadingAnimationData,
                                        rendererSettings: {
                                        preserveAspectRatio	: "xMidYMid slice"
                                        }
                                    }}
                                    height	= { 80 }
                                    width	= { 80 }
                                />		
                            </div>
                        </div>
                    :   null
            }
            <div className="profile-settings-content-container content-section">
                <div className="profile-settings-content">
                    <div className="form-header">
                        <h1>{ t('Profile_Settings') }</h1>
                        <h2>{ t('Free_Simpra_Account') }</h2>
                    </div>
                    <form id="profile-settings-form">
                        <div className="form-row">
                            <div className="form-column">
                                <Textfield
                                    attrs       = {{
                                        id: 'name',
                                        name: 'name',
                                        tabIndex: 1
                                    }}
                                    label       = { t('Name') }
                                    onChange    = { value => updateFormData('firstName', value )}
                                    value       = { s.firstName }
                                    fieldName   = { 'firstName' }
                                    errors      = { errors }
                                    placeholder = { t('Enter_Your_Name') }
                                />
                            </div>
                            <div className="form-column">
                                <Textfield
                                    attrs       = {{
                                        id: 'surname',
                                        name: 'surname',
                                        tabIndex: 2
                                    }}
                                    label       = { t('Surname') }
                                    onChange    = { value => updateFormData('lastName', value )}
                                    value       = { s.lastName }
                                    fieldName   = { 'lastName' }
                                    errors      = { errors }
                                    placeholder = { t('Enter_Your_Surname') }
                                />
                            </div>
                        </div>
                        <div className="form-row email-row">
                            <Textfield
                                attrs       = {{
                                    id: 'email',
                                    name: 'email',
                                    tabIndex: 3,
                                    disabled: 'disabled'
                                }}
                                label       = { t('Email') }
                                value       = { s.email }
                                fieldName   = { 'email' }
                                errors      = { errors }

                            />
                            {
                                profile.emailVerified
                                    ?   <div className="simpra-badge success absolute">{ t('Verified') }</div>
                                    :   <div className="simpra-badge danger absolute">{ t('Not_Verified') }</div>
                            }
                        </div>
                        <div className="form-row">
                            <Phonepicker  
                                code        = { s?.attributes?.phoneCode?.[0] || '' }
                                number      = { s?.attributes?.phoneNumber?.[0] || '' }
                                onChange    = { ({ phone, code }) => changePhoneData(phone, code) }
                                errors      = { errors }
                            />                            
                        </div>
                        <div className="form-row f-wrap">
                            <div className="password-change-reminder">
                                <h1>{ t('Change_My_Password') }</h1>
                                { t('Change_My_Password_Content') }
                            </div>
                        </div>
                        
                        <div className="form-sub-content">
                            <div className="sub-content-header">
                            
                            </div>
                            <div className="sign-out">
                            </div>
                            <div className="send-form">
                                <input tabIndex="10" type="button" value={ t('Save') } onClick={ () => saveAccount() } className="simpra-button pink-shadow" disabled={ showLoading ? 'disabled' : '' } />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default ProfileSettings;